<template>
    <div class="timestamp">
        {{ formattedDate }}
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

/**
 * Component to display a date/time in the local timezone - provides some smart
 * defaults without having to futz with date formatting strings.
 */
export default Vue.extend({
    name: 'timestamp',
    props: {
        date: String,
        includeDay: {type: Boolean, default: false},
        includeDate: {type: Boolean, default: true},
        includeTime: {type: Boolean, default: false},
        includeYear: {type: Boolean, default: false},
        isMysqlDate: {type: Boolean, default: false} // set this to true if the DB field is DATE instead of DATETIME
    },
    computed: {
        formattedDate() {
            // empty (or invalid) date
            if (!moment(this.date).isValid()) {
                return ''
            }

            let format = ''
            if (this.includeDay) {
                format += 'ddd, '
            }
            if (this.includeDate) {
                format += (format.length ? ' ' : '') + 'MMM D'    // Jan 26
                // add year only if it's not the current year (unless specifically requested)
                if (this.includeDate && (this.includeYear || !moment(this.date).isSame(new Date(), 'year'))) {
                    format += " 'YY"    // '21
                }
            }
            if (this.includeTime) {
                format += (format.length ? ' ' : '') + 'h:mm A' // 6:21 PM
            }
            if (this.isMysqlDate) {
                return moment.utc(this.date + ' 12:00:00').local().format(format)
            } else {
                return moment.utc(this.date).local().format(format)
            }
        }
    }
})
</script>
